import React, { useEffect, useState } from "react";
import {
  Drawer,
  Progress,
  Badge,
  List,
  Avatar,
  Result,
  Spin,
  Typography,
  Switch,
  Table,
  Row,
  Col,
  Card,
  Button,
  Tooltip,
  Input,
  Layout,
  message,
} from "antd";
import {
  QuestionCircleOutlined,
  CloseOutlined,
  HomeOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import ImageComponent from "../imageMapping/ImageComponent";
import {
  getProyectosPO,
  getComponentesPO,
} from "../../services/plaOperativo/planOperativoProyectosServices.js";
import PoaPlanOperativoTB from "./PoaPlanOperativoTable";
import AsignarIndicadores from "./IndicadoresPO/AsignarIndicadores.jsx";
import AvancesIndicadores from "./IndicadoresPO/AvancesIndicadores.jsx";
import { getPOPesoResumen } from "../../services/plaOperativo/headerPlanOperativoServices.js";
import { useSelector } from "react-redux";
import { selectAppPermissions } from "../../store/auth/selectors";

import { useParams } from "react-router-dom";
import PoaResumen from "./PoaResumen";

import { getIndicadoresAsignadosProyecto } from "../../services/indicadoresPO/indicadoresService.js";
import RepositorioSoportesTable from "./RepositorioPlanOperativoSostenibilidad.jsx";

const { Title } = Typography;

const PoaPlanOperativo = () => {
  const { id } = useParams();
  const [banderaLink, setBanderaLink] = useState(false);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectProject, setSelectedProject] = useState(null);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [componentes, setComponentes] = useState([]);
  const [error] = useState(null);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedFase2, setSelectedFase2] = useState(null);
  const [codProyecto, setCodProyecto] = useState(null);

  const [loadingComponentes, setLoadingComponentes] = useState(false);

  const [currentView, setCurrentView] = useState("lista"); // 'lista' o 'fase'
  const [dataResumenPOA, setDataResumenPOA] = useState([]);
  const [mostrarPorcentajes, setMostrarPorcentajes] = useState(false);

  const [isTableView, setIsTableView] = useState(false);
  const [mostrarContenidoPadre, setMostrarContenidoPadre] = useState(true);

  const [tieneIndicadoresAsignados, setTieneIndicadoresAsignados] =
    useState(false);

  //Control de Permisos
  const appName = "planOperativo";
  const permissions = useSelector((state) =>
    selectAppPermissions(state, appName)
  );
  const permissionExport = permissions.priv_export === "Y";

  const user = useSelector((state) => state.auth.user);
  const userLogin = user.username;

  // Drawer para el repositorio de soportes
  const [isDrawerRepositorioOpen, setIsDrawerRepositorioOpen] = useState(false);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        // fetch y normalización
        const { data } = await getProyectosPO();
        const dataJSONPesoResumen = await getPOPesoResumen();

        // Normalizar: obtener el array venga como venga
        const rawArray = Array.isArray(dataJSONPesoResumen)
          ? dataJSONPesoResumen
          : Array.isArray(dataJSONPesoResumen?.data)
            ? dataJSONPesoResumen.data
            : Array.isArray(dataJSONPesoResumen?.data?.data)
              ? dataJSONPesoResumen.data.data
              : [];

        // Filtrar (eliminamos estado == 0)
        const filtered = rawArray.filter(item => item != null && String(item.estado) !== '0');

        // Asegurar que cada fila tenga key (Ant Table lo usa)
        const mapped = filtered.map(item => ({ ...item, key: item.oid ?? `${item.codigo_interno}_${Math.random()}` }));

        // setState con los datos ya listos para la tabla
        setDataResumenPOA(mapped);

        if (id) {
          const proyectoEncontrado = data.find(
            (proyecto) => proyecto.codigo_interno === id
          );
          if (proyectoEncontrado) {
            setProjects(data);
            handleOpenModal(proyectoEncontrado);
            setBanderaLink(true);
          } else {
            message.warning(`El proyecto ${id} no existe.`);
            setProjects(data);
            setBanderaLink(false);
          }
        } else {
          setProjects(data);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [id]);

  useEffect(() => {
    const fetchData = async () => {
      if (!codProyecto) return;
      setLoadingComponentes(true);
      setSelectedComponent(null);
      try {
        const response = await getComponentesPO(codProyecto);
        if (id && banderaLink) {
          const componenteEncontrado = response.data.find(
            (componente) => componente.oid === 1
          );

          setSelectedComponent(componenteEncontrado);
          setComponentes(response.data);
        } else {
          setComponentes(response.data);
        }
      } catch (error) {
        console.error("Error fetching components:", error);
      } finally {
        setLoadingComponentes(false);
      }
    };
    fetchData();
  }, [banderaLink, codProyecto, id]);

  const filteredProjects = (projects || []).filter((project) => {
    const code =
      project.proyecto_con_organizaciones.codigo_pre?.toLowerCase() || "";
    const name = project.implementador?.toLowerCase() || "";
    const term = (searchTerm || "").toLowerCase();

    // Devuelve true si coincide con el código O con el nombre
    return code.includes(term) || name.includes(term);
  });

  const handleOpenModal = async (project) => {
    setCodProyecto(project.oid);
    setSelectedProject(project);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setCurrentView("lista");
  };

  const regresarModal = () => {
    setIsModalVisible(true);
    setCurrentView("lista");
  };

  const handleCardClick = async (component) => {
    setCurrentView("lista");

    if (component.oid === 1) {
      setSelectedComponent(component);
      setCurrentView("fase");
    } else if (component.oid === 2) {
      setSelectedComponent(component);
      setIsModalVisible(true);
      setMostrarContenidoPadre(false);

      try {
        const { status: statusAsignados, data: asignados } =
          await getIndicadoresAsignadosProyecto(codProyecto);

        if (statusAsignados === 200 && asignados.length > 0) {
          // ✅ Ya tiene indicadores asignados, mostrar componente de registrar avances
          setIsModalVisible(true); // Drawer padre si se usa como contenedor de avances
          // o abrir Drawer específico para registrar avances si lo tienes separado
          setIsDrawerOpen(true);
          setTieneIndicadoresAsignados(true);
        } else {
          // ✅ No tiene indicadores asignados, mostrar componente de asignación

          setIsDrawerOpen(true); // Drawer que contiene AsignarIndicadores
          setTieneIndicadoresAsignados(false);
        }
      } catch (error) {
        console.error("Error consultando indicadores asignados:", error);
        message.error(
          "Error consultando indicadores asignados. Intenta nuevamente."
        );
        setMostrarContenidoPadre(true); // restaurar vista padre en caso de error
      }
    } else if (component.oid === 3) {
      setIsDrawerRepositorioOpen(true);
    }
  };

  const handleBackClick = () => {
    setSelectedComponent(null);
    setCurrentView("lista");
  };

  if (loading || loadingComponentes)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <Spin size="large" tip="Cargando...">
          <div style={{ minHeight: 100 }} />
        </Spin>
      </div>
    );

  if (error)
    return (
      <Result
        status="error"
        title="Ocurrió un error al cargar los datos"
        subTitle={error.message || "Por favor, intenta nuevamente más tarde."}
        extra={
          <Button type="primary" onClick={() => window.location.reload()}>
            Reintentar
          </Button>
        }
      />
    );

  const handleFaseClick2 = (parentComponent, fase) => {
    setSelectedFase2(fase);
    setIsModalVisible2(true);
    setMostrarContenidoPadre(false);
    setSelectedComponent(parentComponent);
    setCurrentView("fase");
  };

  const handleCloseModal2 = () => {
    setSelectedComponent(null);
    setIsModalVisible2(false);
    setMostrarContenidoPadre(true);
    setCurrentView("lista");
  };

  const handleCloseModal3 = () => {
    setIsDrawerOpen(false);
    setMostrarContenidoPadre(true);
    setCurrentView("lista");
  };

  // 2) Columnas para la tabla de fases (ant-table)
  const columns = [
    {
      title: "Sigla",
      dataIndex: "sigla",
      key: "sigla",
      align: "center",
      render: (sigla, record) => (
        <span
          style={{
            backgroundColor: record.color,
            color: "#fff",
            padding: "2px 6px",
            borderRadius: 4,
          }}
        >
          {sigla}
        </span>
      ),
    },
    {
      title: "Nombre",
      dataIndex: "nombre_corto",
      key: "nombre_corto",
      align: "center",
      render: (texto) => <strong>{texto}</strong>,
    },
    {
      title: "Descripción",
      dataIndex: "nombre_largo",
      key: "nombre_largo",
    },
    {
      title: "Meta total",
      dataIndex: "TotalMeta",
      key: "TotalMeta",
      align: "center",
      render: (val) => (
        <Badge count={val} style={{ backgroundColor: "#1890ff" }} />
      ),
    },
    {
      title: "Meta ejecutada",
      dataIndex: "TotalMetaEjecutada",
      key: "TotalMetaEjecutada",
      align: "center",
      render: (val) => (
        <Badge count={val} style={{ backgroundColor: "#52c41a" }} />
      ),
    },
    {
      title: "% Avance",
      dataIndex: "PorcentajeAvance",
      key: "PorcentajeAvance",
      align: "center",
      render: (text, record) => {
        // Extraemos número del string "xx.x%"
        const porcentajeNumber = parseFloat(text.replace("%", ""));
        return (
          <Progress
            percent={porcentajeNumber}
            size="small"
            strokeColor={record.color}
            trailColor="#eaeaea"
          />
        );
      },
    },
  ];

  return (
    <div className="container">
      <Layout>
        <div className="row mb-2 d-flex align-items-center">
          <div className="col-md-8 linea_separador mb-2 d-flex align-items-center">
            <div
              className="titulo_proyecto"
              style={{ flexBasis: "25%", flexGrow: 0 }}
            >
              <p>
                PROYECTO UTF <br /> COL 166 COL
              </p>
            </div>
            <div className="objeto" style={{ flexBasis: "75%", flexGrow: 0 }}>
              <p>POA - Plan Operativo Anual</p>
            </div>
          </div>
          <div className="col-md-4 d-flex justify-content-center align-items-center flex-column">
            <h2 className="text-center mb-2">Proyectos</h2>
            {permissionExport && (
              <Button
                onClick={() => setMostrarPorcentajes(!mostrarPorcentajes)}
                type="primary"
                style={{ height: 40 }}
              >
                {mostrarPorcentajes
                  ? "Volver a la Vista Principal"
                  : "Porcentajes de Avance POA´s"}
              </Button>
            )}
          </div>
        </div>

        {/* Vista condicional */}
        {mostrarPorcentajes ? (
          <div>
            <PoaResumen data={dataResumenPOA} />
          </div>
        ) : (
          <>
            <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
              <Col span={24}>
                <Input
                  placeholder="Buscar por Código o por nombre"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ width: 400, height: 40, marginRight: 8 }}
                />
                <Button
                  onClick={() => setSearchTerm("")}
                  type="primary"
                  style={{ height: 40 }}
                >
                  Limpiar Filtro
                </Button>
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="proyecto-card-unique-row">
              {loading ? (
                <div>Cargando proyectos...</div>
              ) : (
                filteredProjects
                  .filter((p) => Number(p.estado) === 1) // solo activos
                  .map((project) => (
                    <Col
                      key={project.oid}
                      xs={24}
                      sm={12}
                      md={8}
                      lg={8}
                      xl={6}
                      className="proyecto-card-unique-col"
                    >
                      <Card
                        className="card-menu h-70 redondear card-header align-items-center text-center"
                        style={{
                          body: {
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                          },
                          // Cuando el proyecto está inactivo (0), bajamos la opacidad y bloqueamos interacciones
                          opacity: project.estado === 1 ? 1 : 0.5,
                          pointerEvents: project.estado === 1 ? "auto" : "none",
                        }}
                      >
                        <div
                          style={{
                            height: "auto",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "10px",
                            textAlign: "center",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <div>
                            <h6 className="card-title fw-bold fs-8 m-0">
                              {" "}
                              {project.implementador}
                            </h6>
                            <p className="card-text">
                              <small className="codproyecto">
                                Código:{" "}
                                {project.proyecto_con_organizaciones.codigo_pre}
                              </small>
                            </p>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: 1,
                            width: "100%",
                            overflow: "hidden",
                          }}
                        >
                          <Row
                            gutter={16}
                            style={{
                              width: "100%",
                              justifyContent: "center",
                              backgroundColor: "#fff",
                            }}
                          >
                            <div
                              className="col-md-12"
                              style={{
                                maxHeight: "220px",
                                width: "100%",
                                height: "80%",
                              }}
                            >
                              <Tooltip
                                trigger={["click"]}
                                placement="top"
                                overlayInnerStyle={{
                                  backgroundColor: "rgb(130 186 83)", // tu color
                                  color: "#fff", // texto blanco para contraste
                                  maxWidth: 520, // opcional, limitar ancho
                                  padding: "10px", // opcional, más espacio interno
                                  border: "1px solid #fff", // opcional, borde blanco
                                }}
                                title={(() => {
                                  // parsea sólo si viene como string
                                  const pc =
                                    typeof project.proyecto_con_organizaciones ===
                                      "string"
                                      ? JSON.parse(
                                        project.proyecto_con_organizaciones
                                      )
                                      : project.proyecto_con_organizaciones ||
                                      {};

                                  return (
                                    <div style={{ maxWidth: 220 }}>
                                      {/* Datos básicos */}
                                      <p style={{ margin: 0 }}>
                                        <strong>Código Pre:</strong>{" "}
                                        {pc.codigo_pre}
                                      </p>
                                      <p style={{ margin: 0 }}>
                                        <strong>Código Interno:</strong>{" "}
                                        {project.codigo_interno}
                                      </p>
                                      <p style={{ margin: "4px 0 0" }}>
                                        <strong>Proyecto:</strong> {pc.nombre}
                                      </p>
                                      <p style={{ margin: "4px 0 0" }}>
                                        <strong>Implementador:</strong>{" "}
                                        {project.implementador}
                                      </p>
                                      <p style={{ margin: "4px 0 0" }}>
                                        <strong>Grupo Territorial:</strong>{" "}
                                        {project.grupo_territorial}
                                      </p>
                                      <p style={{ margin: "4px 0 0" }}>
                                        <strong>Proceso:</strong>{" "}
                                        {project.nombre_proceso}
                                      </p>

                                      {/* Organizaciones */}
                                      {pc.organizaciones?.length > 0 && (
                                        <>
                                          <hr
                                            style={{
                                              margin: "8px 0",
                                              borderColor:
                                                "rgba(255,255,255,0.3)",
                                            }}
                                          />
                                          {pc.organizaciones.map((org) => (
                                            <p
                                              key={org.id}
                                              style={{
                                                margin: "4px 0 0",
                                                fontSize: "0.85em",
                                              }}
                                            >
                                              <strong>{org.sigla}</strong>:{" "}
                                              {org.nombre_organizacion}{" "}
                                              <em>
                                                (H:{org.hombres} M:{org.mujeres}
                                                )
                                              </em>
                                            </p>
                                          ))}
                                        </>
                                      )}
                                    </div>
                                  );
                                })()}
                              >
                                <QuestionCircleOutlined
                                  style={{
                                    fontSize: "1.2rem",
                                    color: "#FFF",
                                    cursor: "pointer",
                                    position: "absolute",
                                    top: 8,
                                    right: 8,
                                  }}
                                />
                              </Tooltip>
                              <ImageComponent projectId={project.oid} />
                            </div>
                          </Row>
                        </div>
                        <div
                          className="text-muted mt-auto"
                          style={{
                            display: "flex",
                            backgroundColor: "#317eda",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "auto",
                            padding: "0px",
                          }}
                        >
                          <Tooltip title="Ingresar">
                            <Button
                              className="m-2 btn-primary-lis"
                              onClick={() => handleOpenModal(project)}
                              style={{
                                background: "none",
                                border: "none",
                                // Si estado === 0, atenuamos y bloqueamos clics
                                opacity: project.estado === 1 ? 1 : 0.6,
                                pointerEvents:
                                  project.estado === 1 ? "auto" : "none",
                              }}
                              icon={
                                <HomeOutlined
                                  style={{
                                    fontSize: 20,
                                    color:
                                      project.estado === 1 ? "white" : "#aaa",
                                  }}
                                />
                              }
                            />
                          </Tooltip>
                        </div>
                      </Card>
                    </Col>
                  ))
              )}
            </Row>

            {selectProject && (
              <Drawer
                title={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      position: "relative",
                    }}
                  >
                    <h6
                      style={{
                        margin: 0,
                        fontWeight: "bold",
                        paddingRight: 50,
                      }}
                    >
                      {selectProject.proyecto_con_organizaciones.codigo_pre} -{" "}
                      {selectProject.implementador}
                    </h6>

                    <div>
                      <Button
                        icon={<CloseOutlined />}
                        onClick={handleCloseModal}
                        style={{
                          position: "absolute",
                          right: 0,
                          top: "50%",
                          transform: "translateY(-50%)",
                          border: "none",
                          boxShadow: "none",
                        }}
                      />
                      {selectedComponent?.oid === 1 && (
                        <Button
                          icon={<ArrowLeftOutlined />}
                          onClick={handleBackClick}
                          style={{
                            position: "absolute",
                            right: 40,
                            top: "50%",
                            transform: "translateY(-50%)",
                            border: "none",
                            boxShadow: "none",
                          }}
                        >
                          Regresar
                        </Button>
                      )}
                    </div>
                  </div>
                }
                placement="bottom"
                open={isModalVisible}
                onClose={handleCloseModal}
                closable={false} // ✅ Ocultamos la X nativa
                height="100vh"
                styles={{ body: { padding: 0 } }}
              >
                {mostrarContenidoPadre && (
                  <div style={{ padding: "15px" }}>
                    {currentView === "lista" && (
                      <div style={{ marginBottom: 24 }}>
                        <h3 style={{ margin: 0, fontWeight: 500 }}>
                          Selecciona una opción
                        </h3>
                        <p style={{ margin: 0, color: "#999" }}>
                          Consulta toda la información disponible del proyecto:
                          revisa el Plan Operativo Anual (POA), visualiza los
                          soportes de las visitas, accede al listado completo de
                          participantes, accede a los indicadores, entre otros
                          recursos. Con esta sección, tendrás una visión
                          integral del avance del proyecto.
                        </p>
                      </div>
                    )}

                    {currentView === "lista" ? (
                      <List
                        style={{ padding: "10px" }}
                        grid={{ gutter: 16, column: 4 }} // Se comporta como un grid
                        dataSource={componentes}
                        renderItem={(item) => {
                          const isDisabled = item.estado === 2; // Condición para deshabilitar
                          return (
                            <List.Item
                              style={{
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                transition: "background-color 0.3s ease",
                                padding: "12px",
                                backgroundColor: isDisabled
                                  ? "#eaebee"
                                  : "transparent",
                                borderRadius: "10px",
                              }}
                              onMouseEnter={(e) => {
                                if (!isDisabled) {
                                  e.currentTarget.style.backgroundColor =
                                    "#f0f0f0";
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (!isDisabled) {
                                  e.currentTarget.style.backgroundColor =
                                    "transparent";
                                }
                              }}
                              onClick={() => {
                                if (!isDisabled) {
                                  handleCardClick(item);
                                }
                              }}
                            >
                              <Tooltip title={item.nombre_largo}>
                                <List.Item.Meta
                                  avatar={
                                    <Avatar
                                      shape="square"
                                      style={{
                                        backgroundColor:
                                          item.color || "#d3d3d3",
                                        width: 64,
                                        height: 64,
                                        fontSize: 20,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#000",
                                      }}
                                    >
                                      {item.sigla}
                                    </Avatar>
                                  }
                                  title={item.nombre_corto}
                                  description={
                                    item.descripcion || "Descripción breve..."
                                  }
                                />
                              </Tooltip>
                            </List.Item>
                          );
                        }}
                      />
                    ) : (
                      <div style={{ marginBottom: 24, width: "100%" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 24,
                          }}
                        >
                          <div>
                            <h3 style={{ margin: 0, fontWeight: 500 }}>
                              Plan Operativo Anual (POA)
                            </h3>
                            <p style={{ margin: 0, color: "#999" }}>
                              Accede a la información disponible del Plan
                              Operativo Anual (POA)
                            </p>
                          </div>

                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <span style={{ marginRight: 8 }}>Ver como:</span>
                            <Switch
                              checked={isTableView}
                              onChange={(checked) => setIsTableView(checked)}
                              checkedChildren="Tabla"
                              unCheckedChildren="Cards"
                              style={{ marginLeft: 16 }}
                            />
                          </div>
                        </div>

                        {isTableView ? (
                          // --- VISTA TABLA ---
                          <Table
                            dataSource={(selectedComponent?.fases || []).filter(
                              (f) => Number(f.estado) === 1
                            )}
                            columns={columns}
                            rowKey="oid"
                            pagination={false}
                            onRow={(record) => ({
                              onClick: () => {
                                if (record.estado !== 2 && selectedComponent) {
                                  handleFaseClick2(selectedComponent, record);
                                }
                              },
                              style: {
                                cursor:
                                  record.estado === 2
                                    ? "not-allowed"
                                    : "pointer",
                              },
                            })}
                          />
                        ) : (
                          // --- VISTA CARDS ---
                          <div className="row gx-3 gy-3">
                            {selectedComponent?.fases?.length > 0 ? (
                              selectedComponent.fases
                                .filter((fase) => Number(fase.estado) === 1)
                                .map((fase) => {
                                  // Extraemos el porcentaje como número (sin el '%')
                                  const porcentajeNumber = parseFloat(
                                    fase.PorcentajeAvance.replace("%", "")
                                  );

                                  return (
                                    <div
                                      className="col-12 col-sm-6 col-md-3"
                                      key={fase.oid}
                                    >
                                      <div
                                        className="d-flex flex-column"
                                        style={{
                                          position: "relative",
                                          background: "#f2f2f2",
                                          border: "1px solid #f2f2f2",
                                          borderRadius: 8,
                                          padding: 16,
                                          height: "100%",
                                          cursor:
                                            fase.estado === 2
                                              ? "not-allowed"
                                              : "pointer",
                                          transition:
                                            "transform .2s, box-shadow .2s",
                                        }}
                                        onClick={() =>
                                          fase.estado !== 2 &&
                                          handleFaseClick2(
                                            selectedComponent,
                                            fase
                                          )
                                        }
                                        onMouseEnter={(e) => {
                                          if (fase.estado !== 2) {
                                            e.currentTarget.style.transform =
                                              "translateY(-4px)";
                                            e.currentTarget.style.boxShadow =
                                              "0 8px 20px rgba(0,0,0,0.3)";
                                          }
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.transform =
                                            "translateY(0)";
                                          e.currentTarget.style.boxShadow =
                                            "none";
                                        }}
                                      >
                                        {/* Badge rectangular con la sigla */}
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 16,
                                            left: 16,
                                            backgroundColor: fase.color,
                                            color: "#fff",
                                            padding: "4px 8px",
                                            borderRadius: 4,
                                            fontSize: "0.875rem",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {fase.sigla}
                                        </div>

                                        {/* Espacio para no tapar el badge */}
                                        <div style={{ height: 32 }} />

                                        {/* Título */}
                                        <h4
                                          style={{
                                            color: "#000",
                                            margin: "0 0 8px",
                                            lineHeight: 1.2,
                                          }}
                                        >
                                          {fase.nombre_corto}
                                        </h4>

                                        {/* Descripción */}
                                        <p
                                          style={{
                                            color: "rgba(0, 0, 0, 0.45)",
                                            margin: 0,
                                            flex: 1,
                                          }}
                                        >
                                          {fase.nombre_largo}
                                        </p>

                                        {/* Badges para TotalMeta y TotalMetaEjecutada */}
                                        <div
                                          style={{
                                            marginTop: 12,
                                            display: "flex",
                                            gap: 8,
                                          }}
                                        >
                                          <Badge
                                            count={fase.TotalMeta}
                                            style={{
                                              backgroundColor: "#1890ff",
                                              color: "#fff",
                                              fontSize: "0.75rem",
                                              height: "auto",
                                              padding: "0 6px",
                                            }}
                                            title="Meta total"
                                          />
                                          <Badge
                                            count={fase.TotalMetaEjecutada}
                                            style={{
                                              backgroundColor: "#52c41a",
                                              color: "#fff",
                                              fontSize: "0.75rem",
                                              height: "auto",
                                              padding: "0 6px",
                                            }}
                                            title="Meta ejecutada"
                                          />
                                        </div>

                                        {/* Barra de progreso con Antd Progress */}
                                        <div style={{ marginTop: 16 }}>
                                          <Progress
                                            percent={porcentajeNumber}
                                            size="small"
                                            strokeColor={fase.color}
                                            trailColor="#eaeaea"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                            ) : (
                              <div>No hay fases disponibles</div>
                            )}
                          </div>
                        )}

                        <Row justify="center" style={{ marginBottom: "20px" }}>
                          <Button
                            icon={<ArrowLeftOutlined />}
                            onClick={handleBackClick}
                            style={{ marginRight: "10px", marginTop: "20px" }} // Agrega espacio a la derecha
                          >
                            Regresar
                          </Button>
                        </Row>
                      </div>
                    )}
                  </div>
                )}
              </Drawer>
            )}
          </>
        )}

        <Drawer
          open={isModalVisible2}
          onClose={handleCloseModal2}
          placement="bottom"
          closable={false}
          height="100vh"
          destroyOnClose
          styles={{ body: { padding: 10 } }}
        >
          <PoaPlanOperativoTB
            selectedFase={selectedFase2}
            selectedProject={selectProject}
            regresarAnterior={regresarModal}
            cerrarModal={handleCloseModal2}
          />
        </Drawer>

        <Drawer
          open={isDrawerOpen}
          onClose={handleCloseModal3}
          placement="bottom"
          closable={false} // ✅ Ocultamos la X nativa
          height="100vh"
          destroyOnClose
          styles={{ body: { padding: 0 } }}
        >
          {/* Header personalizado */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px",
              borderBottom: "1px solid #f0f0f0",
              background: "#02172f",
              position: "sticky",
              top: 0,
              zIndex: 10,
            }}
          >
            {selectProject && selectProject.proyecto_con_organizaciones && (
              <Title level={5} style={{ margin: 0, color: "#FFF" }}>
                {tieneIndicadoresAsignados
                  ? "Indicadores del Proyecto: "
                  : "Asignar Indicadores al Proyecto: "}
                {selectProject.proyecto_con_organizaciones.codigo_pre} -{" "}
                {selectProject.implementador}
              </Title>
            )}

            <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={handleCloseModal3}
              style={{
                color: "#02172f",
                fontSize: "1.2rem",
                background: "#FFF",
              }}
            />
          </div>

          <div style={{ padding: "0px 20px" }}>
            {tieneIndicadoresAsignados ? (
              <AvancesIndicadores oidProyecto={codProyecto} />
            ) : (
              <AsignarIndicadores
                oidProyecto={codProyecto}
                onClose={() => setIsDrawerOpen(false)}
              />
            )}
          </div>
        </Drawer>

        <Drawer
          open={isDrawerRepositorioOpen}
          onClose={() => setIsDrawerRepositorioOpen(false)} // 👈 callback
          placement="bottom"
          closable={false} // ✅ Ocultamos la X nativa
          height="100vh"
          destroyOnClose
          styles={{ body: { padding: 0 } }}
        >
          {/* Header personalizado */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px",
              borderBottom: "1px solid #f0f0f0",
              background: "#02172f",
              position: "sticky",
              top: 0,
              zIndex: 10,
            }}
          >
            {selectProject && (
              <Title level={5} style={{ margin: 0, color: "#FFF" }}>
                {"Repositorio del Proyecto: "}
                {selectProject.proyecto_con_organizaciones.codigo_pre} -{" "}
                {selectProject.implementador}
              </Title>
            )}

            <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={() => setIsDrawerRepositorioOpen(false)} // 👈 callback
              style={{
                color: "#02172f",
                fontSize: "1.2rem",
                background: "#FFF",
              }}
            />
          </div>

          <div style={{ padding: "0px 20px" }}>
            <RepositorioSoportesTable oidProyecto={selectProject?.oid || ""} />
          </div>
        </Drawer>
      </Layout>
    </div>
  );
};
export default PoaPlanOperativo;
